/*******************************************************************************
 * Copyright (c) 2024-2026 Malond Limited. All rights reserved.
 * The source code is the property of Malond Limited.
 ******************************************************************************/

import React, { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import EnterpriseList from "../components/Enterprise/EnterpriseList"
import HeaderSelect from "../components/Headers/HeaderSelect"
import LayoutSelect from "../components/Layouts/LayoutSelect"
import HeaderSelectTop from "../components/Headers/HeaderSelectTop"
import { LogOut } from "lucide-react"
import { useRouter } from "next/router"
import { useAuth } from "../hooks/useAuth"

function Welcome() {
  const { logout, userName, isAuthenticated, isLoading, checkAuth } = useAuth()
  const router = useRouter()
  const navigate = useNavigate()
  const [isCheckingSession, setIsCheckingSession] = useState(false)
  const isCheckingRef = useRef(false)

  useEffect(() => {
    let isMounted = true

    if (!isAuthenticated && !isCheckingRef.current) {
      isCheckingRef.current = true
      setIsCheckingSession(true)
      checkAuth(false)
        .then((isAuth) => {
          if (isMounted) {
            setIsCheckingSession(false)
            if (!isAuth) {
              navigate("/login", { replace: true })
            }
          }
        })
        .catch(() => {
          if (isMounted) {
            setIsCheckingSession(false)
            navigate("/login", { replace: true })
          }
        })
        .finally(() => {
          isCheckingRef.current = false
        })
    }

    return () => {
      isMounted = false
    }
  }, [checkAuth, navigate])

  const isRouterReady = router?.isReady ?? true
  if (!isRouterReady || isLoading || isCheckingSession || !isAuthenticated) {
    return <p className="p-8 text-muted-foreground">Загрузка...</p>
  }

  return (
    <React.Fragment>
      <LayoutSelect title="Выбор предприятия">
        <HeaderSelectTop>
          <button
            type="button"
            className="inline-flex cursor-pointer items-center rounded-md border border-border bg-card px-4 py-2 text-sm font-medium text-foreground shadow-xs transition-colors hover:bg-muted focus:ring-2 focus:ring-ring focus:outline-none"
            onClick={logout}
          >
            <LogOut
              className="mr-2 size-4 text-muted-foreground"
              aria-hidden="true"
            />
            <span>Выйти из программы</span>
          </button>
        </HeaderSelectTop>

        <HeaderSelect
          name={"Добро пожаловать, " + (userName || "Кассир") + "!"}
          title={"Выберите организацию"}
          subTitle={
            "Данный выбор будет сохранён для простоты работы. Вы всегда сможете вернуться к выбору в разделе настроек"
          }
        />
        <EnterpriseList />
      </LayoutSelect>
    </React.Fragment>
  )
}

export default Welcome
